// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectFormHeadline_content____Dwq"};